import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import { notEmpty } from "../../../utils/not-empty";
import { useSurveysEnabled } from "../../message/editor/components/hooks/use-surveys-enabled";
import { buildStatusFilter } from "../../survey/hooks/common";
import {
  SupabaseMomentFormSurveyService,
  type MomentFormSurvey,
} from "../../survey/server/supabase-survey-service";

export function useUnlayerSurveys(): UseSupabaseLoaderState<MomentFormSurvey[] | null> {
  const surveysEnabled = useSurveysEnabled();

  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (!surveysEnabled) return null;

      const filter = [buildStatusFilter(["active"])].filter(notEmpty);

      const { data, error } = await new SupabaseMomentFormSurveyService(supabase).getAll(
        account_id,
        {
          order: [{ column: "created_at", dir: "desc" }],
          filter,
        },
      );

      if (error) {
        throw new Error(`Failed to load moment_form_surveys: ${error.message}`);
      }

      return data;
    },
    [surveysEnabled],
  );
}
